const Reorder = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.10156 7.00156C1.10156 6.50451 1.50451 6.10156 2.00156 6.10156H22.0016C22.4986 6.10156 22.9016 6.50451 22.9016 7.00156C22.9016 7.49862 22.4986 7.90156 22.0016 7.90156H2.00156C1.50451 7.90156 1.10156 7.49862 1.10156 7.00156ZM1.10156 12.0016C1.10156 11.5045 1.50451 11.1016 2.00156 11.1016H22.0016C22.4986 11.1016 22.9016 11.5045 22.9016 12.0016C22.9016 12.4986 22.4986 12.9016 22.0016 12.9016H2.00156C1.50451 12.9016 1.10156 12.4986 1.10156 12.0016ZM1.10156 17.0016C1.10156 16.5045 1.50451 16.1016 2.00156 16.1016H22.0016C22.4986 16.1016 22.9016 16.5045 22.9016 17.0016C22.9016 17.4986 22.4986 17.9016 22.0016 17.9016H2.00156C1.50451 17.9016 1.10156 17.4986 1.10156 17.0016Z"
    />
  </>
);

export default Reorder;
